class ProductReelVideo extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.initializeProperties()
    this.addEventListeners()
    this.handleDisplayReelInMobile()
  }

  disconnectedCallback() {
    this.removeEventListeners()
  }

  initializeProperties() {
    this.reelVideo = this.querySelector('.reel-video-wrapper')
    this.closeButton = this.querySelector('.reel-video__close-button')
    this.videoElement = this.querySelector('video')
    this.mobileBreakpoint = 992
    this.descriptionElement = document.querySelector('[id^="Description-"].product-description')
  }

  addEventListeners() {
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.closeReelVideo.bind(this))
    }
    if (this.videoElement) {
      this.videoElement.addEventListener('click', this.toggleFullscreen.bind(this))
    }
    window.addEventListener('scroll', this.throttle(this.handleScroll.bind(this), 50))
  }

  removeEventListeners() {
    if (this.closeButton) {
      this.closeButton.removeEventListener('click', this.closeReelVideo)
    }
    if (this.videoElement) {
      this.videoElement.removeEventListener('click', this.toggleFullscreen)
    }
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll() {
    if (!this.descriptionElement || !this.reelVideo) return

    if (window.innerWidth < this.mobileBreakpoint) {
      const isDisplay = this.isElementInView()
      this.reelVideo.classList.toggle('video-show', isDisplay)
    }
  }

  isElementInView() {
    if (!this.descriptionElement) return false

    const viewportHeight = window.innerHeight
    const elementRect = this.descriptionElement.getBoundingClientRect()
    const visibilityThreshold = viewportHeight * 0.6

    const isTopVisible = elementRect.top < visibilityThreshold
    const isBottomVisible = elementRect.bottom < visibilityThreshold

    return isTopVisible && !isBottomVisible
  }

  closeReelVideo() {
    if (this.reelVideo) {
      this.reelVideo.style.display = 'none'
      if (this.videoElement) {
        this.videoElement.pause()
      }
    }
  }

  async toggleFullscreen() {
    if (!this.videoElement) return

    try {
      if (!document.fullscreenElement) {
        ;(await this.videoElement.requestFullscreen?.()) ||
          this.videoElement.webkitRequestFullscreen?.() ||
          this.videoElement.webkitEnterFullScreen?.()
      }
    } catch (error) {
      console.warn('Fullscreen request failed:', error)
    }
  }

  throttle(func, limit) {
    let inThrottle
    return function (...args) {
      if (!inThrottle) {
        func.apply(this, args)
        inThrottle = true
        setTimeout(() => (inThrottle = false), limit)
      }
    }
  }
}

customElements.define('product-reel-video', ProductReelVideo)
